<template>
  <div class="bt-tool">
    <!-- Hero -->
    <div class="bt-hero">
      <div class="bt-hero-icon">🩸</div>
      <div class="bt-hero-text"><h3>{{ $t('tool.BloodType.title') }}</h3></div>
    </div>

    <!-- Selects -->
    <div class="bt-selects">
      <div class="bt-sel">
        <label>{{ $t('tool.BloodType.father') }}</label>
        <el-select v-model="father" size="medium" @change="calc" class="bt-select">
          <el-option v-for="t in types" :key="'f'+t" :label="t + ' ' + $t('tool.BloodType.type')" :value="t" />
        </el-select>
      </div>
      <span class="bt-cross">×</span>
      <div class="bt-sel">
        <label>{{ $t('tool.BloodType.mother') }}</label>
        <el-select v-model="mother" size="medium" @change="calc" class="bt-select">
          <el-option v-for="t in types" :key="'m'+t" :label="t + ' ' + $t('tool.BloodType.type')" :value="t" />
        </el-select>
      </div>
    </div>

    <!-- Result -->
    <div class="bt-result" v-if="result.length">
      <div class="bt-cards">
        <div v-for="t in types" :key="t" class="bt-card"
          :class="{ on: result.includes(t), best: bestType === t }">
          <span class="bt-card-icon">{{ icons[t] }}</span>
          <span class="bt-card-type">{{ t }} {{ $t('tool.BloodType.type') }}</span>
          <span class="bt-card-prob" v-if="probs[t] !== undefined">{{ probs[t] }}%</span>
          <span class="bt-card-na" v-else>—</span>
        </div>
      </div>
    </div>

    <div class="bt-empty" v-if="!result.length">{{ $t('tool.BloodType.selectHint') }}</div>

    <!-- Reference table -->
    <div class="bt-ref">
      <div class="bt-ref-title">{{ $t('tool.BloodType.table') }}</div>
      <div class="bt-ft-scroll">
        <table class="bt-ft">
          <thead>
            <tr><th>{{ $t('tool.BloodType.parentTypes') }}</th><th v-for="h in types" :key="h">{{ h }} {{ $t('tool.BloodType.type') }}</th></tr>
          </thead>
          <tbody>
            <tr v-for="f in types" :key="f">
              <td class="bt-ft-header">{{ f }} {{ $t('tool.BloodType.type') }}</td>
              <td v-for="m in types" :key="m" :class="{ cur: father === f && mother === m }">
                {{ map[f + '+' + m] || '—' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
var BLOOD_MAP = {
  'O+O':'O', 'O+A':'O、A', 'A+O':'O、A', 'O+B':'O、B', 'B+O':'O、B',
  'O+AB':'A、B', 'AB+O':'A、B', 'A+A':'O、A',
  'A+B':'O、A、B、AB', 'B+A':'O、A、B、AB',
  'A+AB':'A、B、AB', 'AB+A':'A、B、AB',
  'B+B':'O、B', 'B+AB':'A、B、AB', 'AB+B':'A、B、AB',
  'AB+AB':'A、B、AB'
}
var PROB_MAP = {
  'O+O':{ O:100 }, 'O+A':{ O:50, A:50 }, 'A+O':{ O:50, A:50 },
  'O+B':{ O:50, B:50 }, 'B+O':{ O:50, B:50 },
  'O+AB':{ A:50, B:50 }, 'AB+O':{ A:50, B:50 },
  'A+A':{ O:25, A:75 }, 'A+B':{ O:25, A:25, B:25, AB:25 }, 'B+A':{ O:25, A:25, B:25, AB:25 },
  'A+AB':{ A:50, B:25, AB:25 }, 'AB+A':{ A:50, B:25, AB:25 },
  'B+B':{ O:25, B:75 }, 'B+AB':{ A:25, B:50, AB:25 }, 'AB+B':{ A:25, B:50, AB:25 },
  'AB+AB':{ A:25, B:25, AB:50 }
}

export default {
  name:'BloodTypeTool', props:{ config:{ type:Object, default:()=>({}) } },
  data(){ return { types:['O','A','B','AB'], father:'', mother:'', result:[], icons:{ O:'🅾', A:'🅰', B:'🅱', AB:'🆎' } } },
  computed:{
    map(){ return BLOOD_MAP },
    probs(){ if(!this.father||!this.mother)return{}; var k=this.father+'+'+this.mother;return PROB_MAP[k]||{} },
    bestType(){ if(!this.result.length)return'';var p=this.probs,best='',max=0;for(var t in p){if(p[t]>max){max=p[t];best=t}};return best }
  },
  methods:{
    calc(){ if(!this.father||!this.mother){this.result=[];return};var k=this.father+'+'+this.mother;this.result=(BLOOD_MAP[k]||'').split('、') },
    doAction(a){ if(a==='clear'){this.father='';this.mother='';this.result=[]} }
  }
}
</script>

<style scoped>
.bt-tool { display:flex;flex-direction:column;gap:20px; }

.bt-hero { display:flex;align-items:center;gap:14px; }
.bt-hero-icon { font-size:28px;width:52px;height:52px;border-radius:14px;background:#fef0f0;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
.bt-hero-text h3 { margin:0;font-size:16px;font-weight:700;color:#1a1f36; }

.bt-selects { display:flex;align-items:center;justify-content:center;gap:20px; }
.bt-sel { text-align:center; }
.bt-sel label { display:block;font-size:12px;font-weight:600;color:#909399;margin-bottom:6px; }
.bt-select { width:150px; }
.bt-cross { font-size:20px;color:#c0c4cc;font-weight:300;padding-top:18px; }

.bt-cards { display:grid;grid-template-columns:repeat(4,1fr);gap:10px; }
.bt-card {
  padding:20px 8px;border-radius:12px;background:#f4f5f8;text-align:center;
  transition:all .2s;border:2px solid transparent;
  display:flex;flex-direction:column;align-items:center;gap:4px;
}
.bt-card.on { background:#f0f4ff;border-color:#d4dff8; }
.bt-card.best { background:#e8f0fe;border-color:#4e7cff;box-shadow:0 0 12px rgba(78,124,255,.12); }
.bt-card-icon { font-size:30px; }
.bt-card-type { font-size:15px;font-weight:700;color:#909399; }
.bt-card.on .bt-card-type { color:#4e7cff; }
.bt-card-prob { font-size:22px;font-weight:800;color:#4e7cff; }
.bt-card-na { font-size:12px;color:#c0c4cc; }

.bt-ref { }
.bt-ref-title { font-size:13px;font-weight:700;color:#303133;margin-bottom:10px; }
.bt-ft-scroll { overflow-x:auto; }
.bt-ft { width:100%;border-collapse:collapse;font-size:13px; }
.bt-ft th,.bt-ft td { padding:10px 12px;text-align:center;border:1px solid #ebeef5;min-width:70px; }
.bt-ft th { background:#f8f9fb;color:#606266;font-weight:600;font-size:12px; }
.bt-ft-header { background:#f8f9fb;font-weight:600;color:#303133; }
.bt-ft td.cur { background:#f0f4ff;color:#4e7cff;font-weight:700; }

.bt-empty { text-align:center;padding:40px;color:#c0c4cc;font-size:14px; }

@media (max-width:480px) {
  .bt-selects { flex-direction:column;gap:10px; }
  .bt-cross { padding-top:0;transform:rotate(90deg); }
  .bt-cards { grid-template-columns:repeat(2,1fr); }
}
</style>
